import type { FaireProductEntity } from "../../entity_types/product";

export const p_5u2tyuprpa: FaireProductEntity = {
  token: "p_5u2tyuprpa",
  type: "product",
  name: "10 pc Palo Santo sticks bundle w/ info card",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/e8af833c9aa047f855a08e2a8420749a206a3402e6385c75cb2e74c5ec26ca42.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15004d38f95797d838ed70b2845794541e79bfa9051df185e17b0fec5a405aa9.jpeg",
    "https://cdn.faire.com/fastly/682d919f7ed613d26dc3f531564be09a6d719af16ececa68de159601ec0a5435.jpeg",
    "https://cdn.faire.com/fastly/308e4e165b710437b93f73b30beb0ef4e5283f5aacc95733823a7b542582c1f1.jpeg",
  ],
  priceDollars: 5.54,
  description:
    '10 pc Palo Santo sticks w/ info card \nComes with 1 crystal-meaning card\n\nEach stick is approx 4" \n',
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:45.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
